export const defaultStyle = {
  layoutContainer: "imagelist max-w-full relative lg:mx-auto my-0 ",
  heading: "text-center font-Light lg:text-4xl text-[40px] lg:w-full w-2/3 mx-auto leading-[50px] text-white pb-40 tracing-[1px] [&>p]:text-[40px]",
  description: "chefDesc text-2xl md:w-[750px] mx-auto my-0 lg:text-3xl leading-[30px] lg:leading-10 text-center text-white px-10",
  anchor: "anchor",
  listItem: "listItem lg:w-[360px] lg:max-w-full even:pt-[0%]  mx-auto px-[2px] lg:px-auto overflow-hidden",
  list: " zigZagImg max-w-full lg:w-[1170px] w-full mx-auto  max-w-full grid md:grid-cols-3 md:gap-13 gap-10 lg:gap-[24px] grid-cols-2 md:px-23  lg:mx-auto md:mx-0 px-15 md:px-auto relative mt-10 lg:max-h-[860px]",
  textContainer: "bg-darkBlue py-30 text-center ",
  imgMain: "imgMain rounded-[1rem]",
}

export const TREND_RADAR_CHART_TREND_MODAL = {
  layoutContainer:"font-BwSurco",
  title:` title text-18 leading-[1.333] text-purple font-bold flex items-center gap-x-10 cursor-pointer w-fit
  before:inline-block before:content-[""] before:w-[15px] before:h-[15px] before:shrink-0 before:rounded-[50%]  before:border-1 before:border-purple300 before:relative before:top-[-3px]`,
  subtitle:"subtitle text-64 leading-[1.2] font-MDLZBiteType ",
  description:"mt-38 lg:mt-0 flex content-start lg:w-1/2 flex-wrap imgDesc lg:pl-[20px]",
  textContainer:'textContainer flex flex-wrap flex-row-reverse  mt-[25px]  ',
  mainImageWrapper: " block text-center border-1 border-[#D2D4D5]  clacH",
  mainImage:"image flex self-center mx-auto mt-[20px]",
  images:'block text-center border-1 border-[#D2D4D5]  clacH',
  image:'image flex self-center mx-auto mt-[20px]',
  imagesAndChildrenWrapper:'imagesAndChildrenWrapper lg:w-1/2 lg:pr-[20px]',
  endNotes:""
}

export const TREND_RADAR_CHART_SEGMENT_MODAL ={
  ...TREND_RADAR_CHART_TREND_MODAL,
  description:TREND_RADAR_CHART_TREND_MODAL.description+" semgentDesc"
}